import { defineStore } from 'pinia'
import axiosInstance from '@/api/axios'

export const useWorkItemStore = defineStore('workItem', {
  state: () => ({
    dashboard: null,
    dashboardLoading: false,
    counts: { total: 0, overdue: 0 },
    countsLoading: false,
  }),

  getters: {
    overdueItems: (state) => state.dashboard?.overdue || [],
    todayItems: (state) => state.dashboard?.today || [],
    upcomingItems: (state) => state.dashboard?.upcoming || [],
    noDateItems: (state) => state.dashboard?.no_date || [],
    summary: (state) => state.dashboard?.summary || {
      total: 0, overdue_count: 0, today_count: 0, upcoming_count: 0, no_date_count: 0,
    },
    byMainRequest: (state) => state.dashboard?.by_main_request || [],
    hasOverdue: (state) => (state.counts?.overdue || 0) > 0,
  },

  actions: {
    async fetchDashboard() {
      this.dashboardLoading = true
      try {
        const response = await axiosInstance.get('work-items/my-dashboard/')
        this.dashboard = response.data
        // 카운트도 동기화
        if (response.data?.summary) {
          this.counts = {
            total: response.data.summary.total,
            overdue: response.data.summary.overdue_count,
          }
        }
      } catch (error) {
        console.error('Failed to fetch dashboard:', error)
        throw error
      } finally {
        this.dashboardLoading = false
      }
    },

    async fetchCounts() {
      this.countsLoading = true
      try {
        const response = await axiosInstance.get('work-items/counts/')
        this.counts = response.data
      } catch (error) {
        console.error('Failed to fetch counts:', error)
      } finally {
        this.countsLoading = false
      }
    },

    async completeItem(id) {
      const response = await axiosInstance.post(`work-items/${id}/complete/`)
      await this.fetchDashboard()
      return response.data
    },
  },
})
